module.exports = __webpack_public_path__ + "img/arrival_3.ff418ce1.jpg";